import * as ActionTypes from '../constants/actiontypes/user';
import * as DeathDeclarationActionTypes from '../constants/actiontypes/facilita/deathDeclaration';
import * as AuthActionTypes from '../constants/actiontypes/auth';
import *  as axios from 'axios';
import * as R from 'ramda';
import * as urls from '../constants/webapi/facilita';
import * as userUrls from '../constants/webapi/user';
import * as serviceDataUrls from '../constants/webapi/services';
import { getAuthenticationUrl } from '../constants/webapi/auth';
import Letter from '../constants/models/facilita/letter';

export function getUserRepresentingById(id) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USERREPRESENTING_REQUEST });
		return axios.get(urls.userRepresentingByIdUrl(id))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USERREPRESENTING_SUCCESS,
					data: response.data,
				});
				return response.data;
			})
			.catch((error) => {

				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USERREPRESENTING_FAILURE,
					response: error.response,
					// referentId: id
				});
				throw error.statusText;
			});
	};
}

//#region DeathDeclaration
export function createDeathDeclaration(userId, deathDeclaration) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.CREATE_DECLARATION_REQUEST });
		return axios.post(userUrls.declareDeathById(userId), deathDeclaration)
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.CREATE_DECLARATION_SUCCESS,
					data: response.data,
				});
				return response.data;
			})
			.catch((error) => {

				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.CREATE_DECLARATION_FAILURE,
					response: error.response,
					// referentId: id
				});
				throw error.statusText;
			});
	};
}

export function getDeathDeclaration(userId, defaultValues) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.FETCH_DECLARATION_REQUEST });
		return axios.get(userUrls.declareDeathById(userId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_DECLARATION_SUCCESS,
					data: response.data
				});
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined) {
					if (error.response.status === 401) {
						window.location = getAuthenticationUrl();
						return;
					}
					if (error.response.status === 404) {
						dispatch({
							type: DeathDeclarationActionTypes.FETCH_DECLARATION_SUCCESS,
							data: {},
							defaultValues
						});
						return "NotFound";
					}
				}
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_DECLARATION_FAILURE,
					response: error.response,
					// referentId: id
				});
				throw error.statusText;
			});
	};
}

export function updateDeathDeclaration(userId, deathDeclaration) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_DECLARATION_REQUEST });
		const genderToSend = (deathDeclaration.gender === 'Female' || deathDeclaration.gender === 1 || deathDeclaration.gender === '1') ? 'Female'
			: (deathDeclaration.gender === 'Male' || deathDeclaration.gender === 2 || deathDeclaration.gender === '2') ? 'Male'
			: deathDeclaration.gender;
		return axios.put(userUrls.declareDeathById(userId), { ...deathDeclaration, gender: genderToSend, professionalSituation: Array.isArray(deathDeclaration.professionalSituation) ? deathDeclaration.professionalSituation.join(',') : deathDeclaration.professionalSituation })
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_DECLARATION_SUCCESS,
					data: response.data,
				});
				return response.data;
			})
			.catch((error) => {

				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_DECLARATION_FAILURE,
					response: error.response,
					// referentId: id
				});
				throw error.statusText;
			});
	};
}
//#endregion

//#region Documents
export function getDocuments(userId, shouldDispatch, path) {
	if(R.isNil(shouldDispatch)){
		shouldDispatch = true;
	}
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.FETCH_FILES_REQUEST });
		return axios.get(userUrls.userDocumentsUrl(userId, path))
			.then((response) => {
				if(shouldDispatch){
					dispatch({
						type: DeathDeclarationActionTypes.FETCH_FILES_SUCCESS,
						data: response.data,
					});
				}
				return response.data;
			})
			.catch((error) => {
				if (error.response !== undefined) {
					if (error.response.status === 401) {
						window.location = getAuthenticationUrl();
						return;
					}
				}
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_FILES_FAILURE,
					response: error.response,
					// referentId: id
				});
				throw error.statusText;
			});
	};
}

export function uploadDocument(userId, fileType, document, description, filePath) {
	let data = new FormData();
	const config = {
		headers: { 'content-type': 'multipart/form-data' },
		credential: 'include'
	};

	if(!R.isNil(document)){
		data.append("file", document, document.name);
	}else{
		document = {name: null}
	}

	if(!R.isNil(filePath)){
		data.append("filePath", filePath);
	}
	data.append("fileDescription", description);

	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPLOAD_FILE_REQUEST, documentName: document.name, fileType: fileType });
		return axios.post(userUrls.userDocumentUrl(userId, fileType), data, config)
			.then((response) => {
				const file = { fileName: document.name, fileType: fileType, description: description };
				dispatch({
					type: DeathDeclarationActionTypes.UPLOAD_FILE_SUCCESS,
					file: file
				});
				return file;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.UPLOAD_FILE_FAILURE,
					error: error.response,
					documentName: document.name,
					fileType: fileType
				});
				throw error;
			});
	};
}

export function downloadDocument(userId, fileType, path) {
	const encodedFileType = fileType ? encodeURIComponent(fileType) : null;
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.DOWNLOAD_FILE_REQUEST, fileType: fileType });
		return axios.get(userUrls.userDocumentUrl(userId, encodedFileType, path), { responseType: "arraybuffer" })
			.then((response) => {
				var file = new Blob([response.data], { type: response.headers["content-type"] });
				var fileurl = window.URL.createObjectURL(file);
				window.open(fileurl);
				dispatch({
					type: DeathDeclarationActionTypes.DOWNLOAD_FILE_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.DOWNLOAD_FILE_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function downloadDocumentAsBase64(userId, fileType) {

	return axios.get(userUrls.userDocumentUrl(userId, fileType), { responseType: "arraybuffer" })
		.then((response) => {
			return new Promise((resolve, reject) => {
				let blob = new Blob([response.data], { type: response.headers["content-type"] });
				let reader = new FileReader();
				reader.readAsDataURL(blob);
				reader.onload = () => resolve({ base64Content: reader.result, type: blob.type });
				reader.onerror = error => reject(error);
			});

		})
		.catch((error) => {
			throw error;
		});
};

export function deleteDocument(userId, fileName, path) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.DELETE_FILE_REQUEST, fileName: fileName });
		return axios.delete(userUrls.userDocumentUrl(userId, fileName, path))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.DELETE_FILE_SUCCESS,
					data: fileName
				});
				return fileName;
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.DELETE_FILE_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}

export function shareDocuments(userId, toEmailAddresses, fileNames, userRepresentativeId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.SHARE_FILES_REQUEST });
		return axios.post(userUrls.userShareDocument(userId), {
			userRepresentativeId,
			userId,
			fileNames,
			toEmailAddresses
		})
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.SHARE_FILES_SUCCESS,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.SHARE_FILES_FAILURE,
					error: error.response
				});
				throw error;
			});
	};
}
//#endregion

export function getUserMessage(userId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_MESSAGE_REQUEST });
		return axios.get(userUrls.userMessageByIdUrl(userId))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_MESSAGE_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_MESSAGE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getUserConnections(userId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USER_SERVICES_REQUEST, user: userId });
		return axios.get(urls.userConnectionsUrl(userId))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USER_SERVICES_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USER_SERVICES_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function addUserConnection(userId, service) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.ADD_USER_SERVICE_REQUEST, user: userId });
		return axios.post(urls.userConnectionsUrl(userId), service)
			.then((response) => {
				dispatch({
					type: ActionTypes.ADD_USER_SERVICE_SUCCESS,
					data: response.data,
					service: service
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.ADD_USER_SERVICE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function removeUserConnection(userId, connection) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.DELETE_USER_SERVICE_REQUEST, user: userId });
		return axios.delete(urls.userServiceByIdUrl(userId, connection.id))
			.then((response) => {
				dispatch({
					type: ActionTypes.DELETE_USER_SERVICE_SUCCESS,
					service: connection,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.DELETE_USER_SERVICE_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

//#region ServiceData
export function getUserServiceData(userId, serviceType) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_REQUEST, user: userId });
		return axios.get(userUrls.userServiceDataUrl(userId, serviceType))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				// if(error.response !== undefined && error.response.status === 401){
				// 	window.location = getAuthenticationUrl();
				// 	return;
				// }
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_USER_SERVICES_DATA_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function createServiceData(serviceData) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.CREATE_USER_SERVICES_DATA_REQUEST, serviceId: serviceData.serviceId });
		return axios.post(serviceDataUrls.getServiceDataUrl(), serviceData)
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.CREATE_USER_SERVICES_DATA_SUCCESS,
					data: response.data,
					serviceId: serviceData.serviceId
				});
				return response.data;
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.CREATE_USER_SERVICES_DATA_FAILURE,
					response: error.response,
					serviceId: serviceData.serviceId
				});
				throw error.statusText;
			});
	};
}

export function updateServiceData(serviceData) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_USER_SERVICES_DATA_REQUEST, id: serviceData.id });
		return axios.put(serviceDataUrls.getServiceDataByIdUrl(serviceData.id), serviceData)
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_USER_SERVICES_DATA_SUCCESS,
					data: response.data,
					id: serviceData.id
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_USER_SERVICES_DATA_FAILURE,
					response: error.response,
					id: serviceData.serviceId
				});
				throw error.statusText;
			});
	};
}

export function deleteServiceData(id, connectionType) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.DELETE_USER_SERVICES_DATA_REQUEST, id: id, connectionType: connectionType });
		return axios.delete(serviceDataUrls.getServiceDataByIdUrl(id))
			.then(() => {
				dispatch({
					type: DeathDeclarationActionTypes.DELETE_USER_SERVICES_DATA_SUCCESS,
					id: id,
					connectionType: connectionType
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.DELETE_USER_SERVICES_DATA_FAILURE,
					response: error.response,
					id: id
				});
				throw error.statusText;
			});
	};
}

export function setCompletedServiceDataFilling(userId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.SET_COMPLETE_USER_SERVICES_DATA_REQUEST, userId: userId });
		return axios.put(userUrls.completeById(userId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.SET_COMPLETE_USER_SERVICES_DATA_SUCCESS,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.SET_COMPLETE_USER_SERVICES_DATA_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

//#endregion

//#region Letters
export function generateLettersForUserId(userId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.GENERATE_USER_LETTERS_REQUEST, userId: userId });
		return axios.post(urls.generateUserLetterUrlByUserId(userId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.GENERATE_USER_LETTERS_SUCCESS,
					userId: userId,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.GENERATE_USER_LETTERS_FAILURE,
					response: error.response,
					userId: userId
				});
				throw error.statusText;
			});
	};
}

export function generateLettersForUserIdAndUserServiceId(userId, userServiceId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.GENERATE_USER_LETTER_REQUEST, userId, userServiceId });
		return axios.post(urls.generateUserletterUrlByletterIdAndUserServiceId(userId, userServiceId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.GENERATE_USER_LETTER_SUCCESS,
					userId: userId,
					userServiceId: userServiceId,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.GENERATE_USER_LETTER_FAILURE,
					response: error.response,
					userId: userId,
					userServiceId: userServiceId,
				});
				throw error.statusText;
			});
	};
}

export function getLettersForUserId(userId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.FETCH_USER_LETTERS_REQUEST, userId: userId });
		return axios.get(urls.userLetterUrlByUserId(userId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_USER_LETTERS_SUCCESS,
					userId: userId,
					letters: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_USER_LETTERS_FAILURE,
					response: error.response,
					userId: userId
				});
				throw error.statusText;
			});
	};
}

export function getLetterInformationByLetterId(letterId) {
	return axios.get(urls.letterUrlByletterId(letterId))
		.then((response) => {
			return response.data;

		})
		.catch((error) => {
			throw error;
		});
}

export function updateLetterById(userletter) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_REQUEST, userletterId: userletter.id });
		const urltest = urls.userletterUrlByletterId(userletter.id);
		return axios.put(urltest, new Letter(userletter))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_SUCCESS,
					userletterId: userletter.id,
					userletter: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_FAILURE,
					response: error.response,
					userletterId: userletter.id
				});
				throw error.statusText;
			});
	};
}

export function validateLetter(userletter) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_REQUEST, userletterId: userletter.id });
		return axios.put(urls.userletterUrlByletterId(userletter.id) + "/validate")
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_SUCCESS,
					userletterId: userletter.id,
					userletter: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_FAILURE,
					response: error.response,
					userletterId: userletter.id
				});
				throw error.statusText;
			});
	};
}

export function abandonLetter(userletter) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_REQUEST, userletterId: userletter.id });
		return axios.put(urls.userletterUrlByletterId(userletter.id) + "/abandon")
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_SUCCESS,
					userletterId: userletter.id,
					userletter: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_USER_LETTER_FAILURE,
					response: error.response,
					userletterId: userletter.id
				});
				throw error.statusText;
			});
	};
}

export function downloadLetter(userLetterId) {
	return axios.get(urls.letterContentUrlByletterId(userLetterId), { responseType: "arraybuffer" })
		.then((response) => {
			var file = new Blob([response.data], { type: response.headers["content-type"] });
			var fileurl = window.URL.createObjectURL(file);
			window.open(fileurl);
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error;
		});
};
//#endregion

//#region UserRepresentative
export function getUserRepresentativesForUserId(userId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.FETCH_REFERENTS_REQUEST, userId: userId });
		return axios.get(urls.userRepresentativeByUserIdUrl(userId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_REFERENTS_SUCCESS,
					userId: userId,
					referents: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_REFERENTS_FAILURE,
					response: error.response,
					userId: userId
				});
				throw error.statusText;
			});
	};
}

export function createUserRepresentativeForUserId(userId, userRepresentative) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.CREATE_REFERENT_REQUEST, userId: userId });
		return axios.post(urls.userRepresentativesUrl(), userRepresentative)
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.CREATE_REFERENT_SUCCESS,
					userId: userId,
					referent: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.CREATE_REFERENT_FAILURE,
					response: error.response,
					userId: userId
				});
				throw error.statusText;
			});
	};
}

export function updateUserRepresentativeForUserId(userId, userRepresentative) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_REFERENT_REQUEST, userId: userId });
		return axios.put(urls.userRepresentativesByIdUrl(userRepresentative.id), userRepresentative)
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_REFERENT_SUCCESS,
					userId: userId,
					referent: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_REFERENT_FAILURE,
					response: error.response,
					userId: userId
				});
				throw error.statusText;
			});
	};
}

export function deleteUserRepresentativeForUserId(userId, userRepresentativeId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.DELETE_REFERENT_REQUEST, userId: userId });
		return axios.delete(urls.userRepresentativesByIdUrl(userRepresentativeId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.DELETE_REFERENT_SUCCESS,
					userId: userId,
					referentId: userRepresentativeId
				});
			})
			.catch((error) => {
				dispatch({
					type: DeathDeclarationActionTypes.DELETE_REFERENT_FAILURE,
					response: error.response,
					userId: userId
				});
				throw error.statusText;
			});
	};
}

export function InviteUserRepresentative(userRepresentativeId) {
	return axios.post(urls.userRepresentativesInvitationByIdUrl(userRepresentativeId))
		.then((response) => {
			return;
		})
		.catch((error) => {
			throw error.statusText;
		});
}
//#endregion

//#region User Address
export function getAddressesByUserId(userId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USER_ADDRESS_REQUEST, userId: userId });
		return axios.get(urls.userAddressByUserIdUrl(userId))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USER_ADDRESS_SUCCESS,
					addresses: response.data,
					userId: userId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USER_ADDRESS_FAILURE,
					response: error.response,
					userId: userId
				});
				throw error.statusText;
			});
	};
}

export function updateAddressById(userId, address) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_USER_ADDRESS_REQUEST, userId: userId, addressId: address.id });
		return axios.put(urls.userAddressByUserIdAndAddressIdUrl(userId, address.id), address)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_USER_ADDRESS_SUCCESS,
					address: address,
					userId: userId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_USER_ADDRESS_FAILURE,
					response: error.response,
					userId: userId,
					addressId: address.id
				});
				throw error.statusText;
			});
	};
}
//#endregion

//#region User & Security
export function updateUser(user) {
	if (R.isNil(user.isEnabled)) {
		user.isEnabled = true;
	}
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_USER_REQUEST, userId: user.id });
		return axios.put(urls.userByIdUrl(user.id), user)
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_USER_SUCCESS,
					user: user
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_USER_FAILURE,
					response: error.response,
					userId: user.id
				});
				throw error.statusText;
			});
	};
}

export function sendOTPCode(phoneNumber) {
	return (dispatch) => {
		dispatch({ type: AuthActionTypes.SEND_OTP_CODE_REQUEST, phoneNumber: phoneNumber });
		return axios.post(urls.sendOTPUrl(), { phoneNumber: phoneNumber })
			.then((response) => {
				dispatch({
					type: AuthActionTypes.SEND_OTP_CODE_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: AuthActionTypes.SEND_OTP_CODE_FAILURE,
					reason: error.response.status
				});
				if (error.response.status === 409)
					throw new Error("AlreadyExistingPhoneNumber");
			});
	};
}

export function verifyOTPCode(phoneNumber, otpCode) {
	return (dispatch) => {
		dispatch({ type: AuthActionTypes.VERIFY_OTP_REQUEST, phoneNumber: phoneNumber, otpCode: otpCode });
		return axios.post(urls.verifyOTPUrl(), { phoneNumber: phoneNumber, otpCode: otpCode })
			.then((response) => {
				dispatch({
					type: AuthActionTypes.VERIFY_OTP_SUCCESS,
					data: response.data,
					phoneNumber: phoneNumber
				});
			})
			.catch((error) => {
				dispatch({
					type: AuthActionTypes.VERIFY_OTP_FAILURE,
					response: error.response
				});
				if (error.response.status === 400 && error.response.data.errors?.hasOwnProperty("otpCode")) {
					throw new Error("InvalidOtpCode");
				}
				throw new Error(error.statusText);
			});
	};
}

export function changePhoneNumber(phoneNumber, userId) {
	return (dispatch) => {
		dispatch({ type: AuthActionTypes.SEND_OTP_CODE_REQUEST, phoneNumber: phoneNumber });
		return axios.post(userUrls.changePhoneNumberUrl(userId), { newPhoneNumber: phoneNumber })
			.then((response) => {
				dispatch({
					type: AuthActionTypes.SEND_OTP_CODE_SUCCESS,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch({
					type: AuthActionTypes.SEND_OTP_CODE_FAILURE,
					reason: error.response.status
				});
				if (error.response.status === 409)
					throw new Error("AlreadyExistingPhoneNumber");
			});
	};
}

export function updateUserSecurity(phoneNumber, otpCode, userId) {
	return (dispatch) => {
		dispatch({ type: AuthActionTypes.VERIFY_OTP_REQUEST, phoneNumber: phoneNumber, otpCode: otpCode });
		return axios.put(userUrls.userSecurityByIdUrl(userId), { id: userId, oTPCode: otpCode, newPhoneNumber: phoneNumber })
			.then((response) => {
				dispatch({
					type: AuthActionTypes.VERIFY_OTP_SUCCESS,
					data: response.data,
					phoneNumber: phoneNumber
				});
			})
			.catch((error) => {
				dispatch({
					type: AuthActionTypes.VERIFY_OTP_FAILURE,
					response: error.response
				});
				if (error.response.status === 400 && error.response.data.errors?.hasOwnProperty("otpCode")) {
					throw new Error("InvalidOtpCode");
				}
				throw error.statusText;
			});
	};
}
//#endregion

export function fetchPartnerCustomization(partnerId) {
	return axios.get(userUrls.getPartnerCustomizationUrl(partnerId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			if (error.response !== undefined && error.response.status === 401) {
				window.location = getAuthenticationUrl();
				return;
			}
			throw error.statusText;
		});
}

//#region onBoarding
export function getUserInfoById(userId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.FETCH_ONBOARDINGUSER_REQUEST });
		return axios.get(userUrls.userByIdUrl(userId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_ONBOARDINGUSER_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_ONBOARDINGUSER_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function updateUserInfoById(userInfo) {
	if (R.isNil(userInfo.isEnabled)) {
		userInfo.isEnabled = true;
	}
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGUSER_REQUEST });
		return axios.put(userUrls.userByIdUrl(userInfo.id), { ...userInfo, professionalSituation: Array.isArray(userInfo.professionalSituation) ? userInfo.professionalSituation.join(',') : userInfo.professionalSituation })
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGUSER_SUCCESS,
					data: userInfo,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGUSER_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function updateOnboardingUserAddressById(userId, address) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGUSER_ADDRESS_REQUEST });
		return axios.put(userUrls.userAddressByIdWithIdUrl(userId, address.id), address)
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGUSER_ADDRESS_SUCCESS,
					data: address,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGUSER_ADDRESS_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getOnboardingUserAddressesByUserId(userId) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.FETCH_ONBOARDINGUSER_ADDRESS_REQUEST, userId: userId });
		return axios.get(urls.userAddressByUserIdUrl(userId))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_ONBOARDINGUSER_ADDRESS_SUCCESS,
					addresses: response.data,
					userId: userId
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.FETCH_ONBOARDINGUSER_ADDRESS_FAILURE,
					response: error.response,
					userId: userId
				});
				throw error.statusText;
			});
	};
}

export function updateUserConnectionBatch(userId, services) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.ADD_USER_SERVICE_BATCH_REQUEST });
		return axios.post(userUrls.userServicesBatchUrl(userId), services.map(s => { return { connectionType: s }; }))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.ADD_USER_SERVICE_BATCH_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.ADD_USER_SERVICE_BATCH_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function updateOnboardingStep(userId, step) {
	return (dispatch) => {
		dispatch({ type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGSTEP_REQUEST, step: step });

		return axios.put(userUrls.updateOnBoardingStepByIdUrl(userId, step))
			.then((response) => {
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGSTEP_SUCCESS,
					data: step
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: DeathDeclarationActionTypes.UPDATE_ONBOARDINGSTEP_FAILURE,
					response: error.response
				});
				throw error.statusText;
			});
	};
}

export function getCurrentPrices(userId) {
	return axios.get(userUrls.getCurrentPricesUrl(userId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			throw error.statusText;
		});
}
//#endregion

//#region Invoices
export function fetchInvoices(userId) {
	return axios.get(userUrls.getInvoicesByUserIdUrl(userId))
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			throw error.statusText;
		});
}
//#endregion

export function addUserRole(userId) {
	return axios.get(urls.addUserRoleUrl(userId))
		.then((response) => {
			if (sessionStorage.getItem("access_token") !== undefined) {
				sessionStorage.removeItem("access_token");
			}
			sessionStorage.setItem("access_token", response.data.jwtToken);
			axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.jwtToken;
			return response.data;
		})
		.catch((error) => {
			throw error.statusText;
		});
}


